import React, { useRef, useState, useEffect } from "react";
import { Button, Box } from "@mui/material";

interface Props {
  text: string;
  onChange: (value: string) => void;       // Para resultados finales
  onInterim?: (value: string) => void;     // Para resultados interinos
  onRecordingStateChange?: (recording: boolean) => void;
}

const SugerenciaConDictado: React.FC<Props> = ({
  text,
  onChange,
  onInterim,
  onRecordingStateChange,
}) => {
  const recognizerRef = useRef<any>(null);
  const [isRecording, setIsRecording] = useState(false);

  const idioma = navigator.languages?.[0] || navigator.language || "es-ES";

  const iniciarGrabacion = () => {
    const SpeechRecognition =
      (window as any).webkitSpeechRecognition ||
      (window as any).SpeechRecognition;

    if (!SpeechRecognition) {
      alert("Tu navegador no soporta reconocimiento de voz.");
      return;
    }

    const recognizer = new SpeechRecognition();
    recognizerRef.current = recognizer;

    recognizer.lang = idioma;
    recognizer.continuous = true;
    recognizer.interimResults = true;

    recognizer.onresult = (event: any) => {
      let interim = "";
      let final = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const result = event.results[i];
        if (result.isFinal) {
          final += result[0].transcript + " ";
        } else {
          interim += result[0].transcript;
        }
      }

      // Resultados finales
      if (final) {
        const nuevoTexto = text ? text + " " + final.trim() : final.trim();
        onChange(nuevoTexto);
      }

      // Resultados interinos
      onInterim?.(interim);
    };

    recognizer.onstart = () => setIsRecording(true);
    recognizer.onend = () => setIsRecording(false);

    recognizer.start();
  };

  const detenerGrabacion = () => {
    recognizerRef.current?.stop();
  };

  useEffect(() => {
    onRecordingStateChange?.(isRecording);
  }, [isRecording]);

  return (
    <Box display="flex" gap={1}>
      {!isRecording ? (
        <Button variant="outlined" onClick={iniciarGrabacion}>
          🎤 Iniciar dictado
        </Button>
      ) : (
        <Button variant="contained" color="error" onClick={detenerGrabacion}>
          ⏹ Detener
        </Button>
      )}
    </Box>
  );
};

export default SugerenciaConDictado;
